import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fa092a48")

_pushScopeId("data-v-fa092a48")
const _hoisted_1 = { class: "service-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "service-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "service-title" }, "包含")
], -1)
const _hoisted_3 = { class: "service-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "service-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "service-title" }, "不包含")
], -1)
const _hoisted_5 = { class: "service-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($data.includeService, (item, index) => {
      return (_openBlock(), _createBlock("div", { key: item }, [
        _createVNode("div", _hoisted_3, _toDisplayString(index + 1) + ". " + _toDisplayString(item), 1)
      ]))
    }), 128)),
    _hoisted_4,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($data.noIncludeService, (item, index) => {
      return (_openBlock(), _createBlock("div", { key: item }, [
        _createVNode("div", _hoisted_5, _toDisplayString(index + 1) + ". " + _toDisplayString(item), 1)
      ]))
    }), 128))
  ]))
})